import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';

const emptyTenant = { tenant_id: '', domain: '', node_id: '', enabled: false, rut: '', nombre: '', fantasia: '', giro: '' };

function headers() {
  const token = sessionStorage.getItem('syrakis_token');
  return { Accept: 'application/json', 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

export default function TenantCurrentPage() {
  const [tenant, setTenant] = useState(emptyTenant);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('/api/tenant/current', { credentials: 'same-origin', headers: headers() })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'No se pudo cargar el tenant.');
        setTenant(data.tenant);
      })
      .catch((reason) => setError(reason.message))
      .finally(() => setLoading(false));
  }, []);

  function update(field, value) {
    setTenant((current) => ({ ...current, [field]: value }));
    setMessage('');
    setError('');
  }

  async function save(event) {
    event.preventDefault();
    setSaving(true);
    setMessage('');
    setError('');
    try {
      const response = await fetch('/api/tenant/current', {
        method: 'PUT', credentials: 'same-origin', headers: headers(),
        body: JSON.stringify({ tenant: { domain: tenant.domain, rut: tenant.rut, nombre: tenant.nombre, fantasia: tenant.fantasia, giro: tenant.giro } }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'No se pudo guardar el tenant.');
      setMessage(data.message || 'Tenant actualizado correctamente.');
    } catch (reason) {
      setError(reason.message);
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="dashboard-main-body"><div className="card p-32">Cargando tenant activo...</div></div>;

  return (
    <div className="dashboard-main-body">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <div><h4 className="mb-8">Tenant actual</h4><p className="text-secondary-light mb-0">Edita únicamente los datos del tenant asociado a tu sesión.</p></div>
        <span className={`badge ${tenant.enabled ? 'bg-success-50 text-success-600' : 'bg-danger-50 text-danger-600'}`}>
          <Icon icon="solar:shield-check-linear" className="me-1" /> {tenant.enabled ? 'Activo' : 'Suspendido'}
        </span>
      </div>

      {error && <div className="alert alert-danger mb-20">{error}</div>}
      {message && <div className="alert alert-success mb-20">{message}</div>}

      <form onSubmit={save} className="row gy-4">
        <div className="col-xl-8">
          <div className="card h-100"><div className="card-body p-24">
            <h6 className="mb-20">Identidad del tenant owner</h6>
            <div className="row gy-20">
              <div className="col-md-8"><label className="form-label">Dominio canónico</label><input className="form-control" value={tenant.domain || ''} onChange={(event) => update('domain', event.target.value)} required /><small className="text-secondary-light">Se usa como identificador de acceso del tenant.</small></div>
              <div className="col-md-4"><label className="form-label">RUT</label><input className="form-control" value={tenant.rut || ''} onChange={(event) => update('rut', event.target.value)} /></div>
              <div className="col-12"><label className="form-label">Razón social</label><input className="form-control" value={tenant.nombre || ''} onChange={(event) => update('nombre', event.target.value)} required /></div>
              <div className="col-md-6"><label className="form-label">Nombre de fantasía</label><input className="form-control" value={tenant.fantasia || ''} onChange={(event) => update('fantasia', event.target.value)} /></div>
              <div className="col-md-6"><label className="form-label">Giro / actividad</label><input className="form-control" value={tenant.giro || ''} onChange={(event) => update('giro', event.target.value)} /></div>
            </div>
            <div className="d-flex justify-content-end mt-24"><button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Guardando...' : 'Guardar cambios'}</button></div>
          </div></div>
        </div>
        <div className="col-xl-4">
          <div className="card"><div className="card-body p-24">
            <h6 className="mb-20">Contexto de infraestructura</h6>
            <dl className="mb-0">
              <dt className="text-secondary-light fw-normal">tenant_id</dt><dd className="fw-semibold mb-16">{tenant.tenant_id}</dd>
              <dt className="text-secondary-light fw-normal">Nodo asignado</dt><dd className="fw-semibold mb-16">{tenant.node_id || '—'}</dd>
              <dt className="text-secondary-light fw-normal">Empresa propietaria</dt><dd className="fw-semibold mb-0">#{tenant.owner_empresa_id || '—'}</dd>
            </dl>
            <div className="alert alert-info mt-20 mb-0">El identificador del tenant y el nodo son gestionados por la plataforma. No se exponen como campos editables.</div>
          </div></div>
        </div>
      </form>
    </div>
  );
}
